import { GetOrganizationSummaryResponseBodyType } from "@intelligems/ig-types/functions/organization-summaries/get-organization-summary";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { organizationsKeys } from "@src/api/queryKeys";
import { useSuspenseQuery } from "@tanstack/react-query";

import { api } from "../api";

/**
 * Rejects when the payload has no `org`: the schema declares it required and
 * there is no safe default organization. A rejected refetch keeps the cached
 * summary instead of replacing it.
 */
export const getOrganizationSummary =
  async (): Promise<GetOrganizationSummaryResponseBodyType> => {
    const resp =
      await api.get<Partial<GetOrganizationSummaryResponseBodyType> | null>(
        `/v2/organizations/subscriptions`
      );

    const org = resp.data?.org;

    if (!org) {
      throw new Error(
        "GET /v2/organizations/subscriptions responded without an organization summary"
      );
    }

    return { org };
  };

export const useGetOrganizationSummary = () => {
  const org = useGetOrg();
  return useSuspenseQuery<GetOrganizationSummaryResponseBodyType>({
    queryKey: organizationsKeys.orgSummary(org.data.org.id),
    queryFn: async () => getOrganizationSummary(),
    refetchOnWindowFocus: "always",
  });
};
